module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [(_vm.userProfileClient.profile.id) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Логин и пароль"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Логин")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.username),
      expression: "userProfileClient.user.username"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Введите логин",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.password),
      expression: "userProfileClient.user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveLoginPassword()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Профиль пользователя"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Отображаемое имя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.name),
      expression: "userProfileClient.client.name"
    }],
    staticClass: "input displayName",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.roleId),
      expression: "userProfileClient.user.roleId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.user, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.loggedRole <= 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("СуперАдминистратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 4) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Партнер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 8) ? _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Реферер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 16) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Клиент")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 32) ? _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Клиент Автоматизации")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Центр затрат")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.costCenterId),
      expression: "userProfileClient.client.costCenterId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "costCenterId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n                  " + _vm._s(costCenter.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])]), _vm._v(" "), (_vm.userProfileClient && _vm.userProfileClient.client && _vm.userProfileClient.client.clientConfig) ? _c('tab-pane', {
    attrs: {
      "label": "Client Config"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])]), _vm._v(" "), _c('tbody', [_vm._l((Object.entries(_vm.userProfileClient.client.clientConfig)), function(param, index) {
    return _c('tr', [(_vm.isSimpleParam(param) && param[0] !== 'availableSmsGateways') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isSimpleParam(param) && param[0] !== 'availableSmsGateways') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "placeholder": "Параметр не указан",
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "",
      "value": "Доступные смс шлюзы"
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.availableSmsGatewaysStr),
      expression: "availableSmsGatewaysStr"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.availableSmsGatewaysStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.availableSmsGatewaysStr = $event.target.value
      }
    }
  })])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Перезвон по-умолчанию")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Стратегия",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.strategy),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.strategy"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.strategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig, "strategy", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Количество попыток",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters, "attempts", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Время ожидания",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters, "waitMinutes", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tariff billing"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Биллинг")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Тариф",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "control tariff"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.tariff),
      expression: "userProfileClient.client.tariff"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "tariff", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tariffs), function(tariff) {
    return _c('option', {
      domProps: {
        "value": tariff.id
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.generateTariffLabel(tariff)) + "\n                        ")])
  }), 0)])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Биллинг",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "control billing"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.billingEnable),
      expression: "userProfileClient.client.billingEnable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "billingEnable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("По умолчанию")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Включён")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Выключён")])])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveClientConfig()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])])]) : _vm._e(), _vm._v(" "), (!!_vm.userProfileClient && _vm.userProfileClient.client && _vm.userProfileClient.client.id && _vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": "Лицевой счёт"
    }
  }, [_c('Balance', {
    attrs: {
      "client-id": _vm.userProfileClient.client.id,
      "reload-client": _vm.load,
      "client-balance": _vm.userProfileClient.clientBalance
    }
  })], 1) : _vm._e()], 1)], 1) : (_vm.id === 'new') ? _c('article', {
    staticClass: "tile is-child box createNew"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Логин")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.username),
      expression: "userProfileClient.user.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите логин",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.password),
      expression: "userProfileClient.user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.roleId),
      expression: "userProfileClient.user.roleId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.user, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.loggedRole <= 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("СуперАдминистратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 4) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Партнер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 8) ? _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Реферер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 16) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Клиент")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 32) ? _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Клиент Автоматизации")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Центр затрат")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.costCenterId),
      expression: "userProfileClient.client.costCenterId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "costCenterId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n              " + _vm._s(costCenter.name) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать")])])]) : _c('article', [_c('loader-rollers1')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6753cc00"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/users/User.vue
// module id = 663
// module chunks = 42